<template>
  <v-card v-if="shadowData">
    <v-card-text>
      <v-textarea
        v-model="shadowData.notes"
        label="Notes"
        rows="3"
        auto-grow
        outlined
        dense
        placeholder="Optional note to save with the node"
        @change="emit"
      />
      <v-switch
        v-model="shadowData.notesInFlow"
        label="Display note in flow"
        hint="Show the note text below the node on the canvas"
        persistent-hint
        @change="emit"
      />
      <v-divider class="my-3" />
      <v-switch
        v-model="shadowData.alwaysOutputData"
        label="Always output data"
        @change="emit"
      />
      <v-switch
        @change="emit"
        v-model="shadowData.continueOnFail"
        label="Continue on fail"
      />
      <v-switch
        @change="emit"
        v-model="shadowData.executeOnce"
        label="Execute Once"
      />
      <v-switch
        @change="emit"
        v-model="shadowData.retryOnFail"
        label="Retry On Fail"
      />
      <v-text-field
        @change="emit"
        v-if="shadowData.retryOnFail"
        type="number"
        :min="2"
        :max="5"
        v-model="shadowData.maxTries"
      />
      <v-text-field
        @change="emit"
        v-if="shadowData.retryOnFail"
        type="number"
        :min="0"
        :max="5000"
        v-model="shadowData.waitBetweenTries"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { deepCopy } from "../../helpers/object";
const defaultData = {
  notes: "",
  notesInFlow: false,
  alwaysOutputData: false,
  continueOnFail: false,
  executeOnce: false,
  retryOnFail: false,
  maxTries: 3,
  waitBetweenTries: 1000,
};
export default {
  props: ["value"],
  data: () => ({
    shadowData: null,
  }),
  mounted() {
    this.setShadowData();
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.setShadowData();
      },
    },
  },
  methods: {
    emit() {
      this.$emit("input", this.shadowData);
    },
    setShadowData() {
      this.shadowData = deepCopy(this.value || defaultData);
    },
  },
};
</script>